import React from 'react';
import { withTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';

import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';
import SearchActions from '../../../../actions/SearchActions';
import ResultsStore from '../../../../stores/ResultsStore';

class CategoriesFilter extends React.Component {
	constructor(props) {
		super(props);

		this.handleCheckboxChangeByCategory = this.handleCheckboxChangeByCategory.bind(this);
		this.handleCategoryOnlyClick = this.handleCategoryOnlyClick.bind(this);
		this.handleResetCategoriesClick = this.handleResetCategoriesClick.bind(this);
	}

	handleCheckboxChangeByCategory = (event, isInputChecked, category) => {
		const { profile, t } = this.props;
		event.persist();
		// SearchActions.showHotelLoader(true);
		FiltersActions.filterByCategories(category, isInputChecked);
		setTimeout(() => {
			SearchActions.executeFilterSearch();
		}, 10);
		setTimeout(() => {
			FiltersActions.filterByCategories(category, isInputChecked);
		}, 500);

		const filter_value = t(isInputChecked ? 'FilterByCategory' : 'DontFilterByCategory', { category });
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.CATEGORIES,
			filter_value,
		);
	};

	handleCategoryOnlyClick = (event) => {
		const { profile, t } = this.props;

		event.persist();
		let category_only = event.target.getAttribute('data-category');
		FiltersActions.filterByCategoriesOnly(category_only);
		setTimeout(() => {
			SearchActions.executeFilterSearch();
		}, 10);
		setTimeout(() => {
			FiltersActions.filterByCategoriesOnly(category_only);
		}, 500);

		const filter_value = t('ShowOnlyCategory', { category: category_only });
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.CATEGORY_ONLY,
			filter_value,
		);
	};

	handleResetCategoriesClick = (event) => {
		const { profile, t } = this.props;

		event.persist();
		FiltersActions.resetCategoriesFilter();
		setTimeout(FiltersActions.resetCategoriesFilter, 10);

		const filter_value = t('ResetCategoriesFilter');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.RESET_CATEGORIES_FILTER,
			filter_value,
		);
	};

	render() {
		const { t } = this.props;
		const data = this.props.filter;
		const multiple_categories = Object.keys(data).length > 1;

		const CATEGORIES = [];
		for (let category in data) {
			const category_key = category.toLowerCase().replace(' ', '-');
			CATEGORIES.push(
				<div className="checkbox-container" key={category_key}>
					<FilterCheckboxWithLabel
						checked={data[category]}
						category={category}
						label={t(`Filters.${category}`)}
						onChange={(e, c, category) => this.handleCheckboxChangeByCategory(e, c, category)}
					/>
					{multiple_categories ? (
						<button
							className="btn btn-link"
							data-category={category}
							onClick={this.handleCategoryOnlyClick}
							aria-label={t('SelectOnly', { category: t(`Filters.${category}`) })}
						>
							{t('Only')}
						</button>
					) : null}
				</div>,
			);
		}

		return (
			<div className="filter disabled" data-testid="filter-categories">
				<label className="filter-title" htmlFor="categories-filter">
					{t('Categories')}
				</label>
				<div name="categories-filter" className="check-list" aria-label={t('Categories')}>
					{CATEGORIES}
				</div>
				{CATEGORIES.length > 1 ? (
					<button
						className="clear-button-wrap"
						onClick={this.handleResetCategoriesClick}
						aria-label={t('ResetCategories')}
					>
						<div className="clear-button-img" />
					</button>
				) : null}
			</div>
		);
	}
}

export default withTranslation()(CategoriesFilter);
